const style = {
  textAlign: 'center',
  paddingTop: '40px',
};
export default {
  style,
};



// WEBPACK FOOTER //
// ./src/scenes/components/Footer/style.js